/* Meterware: ersetzt im Cart-Drawer den statischen Property-Text durch die tatsaechliche Meterzahl.
   Faellt bei Fehlern stillschweigend auf den Property-Text zurueck. */
(function () {
  var PROP_KEY = 'Stoffmenge';
  var SEL = '[data-essential-cart-element="line-item-properties"]';
  var MARK = 'data-meterware-done';
  var timer = null;
  var busy = false;

  function meter(q) {
    var ganz = Math.floor(q / 2);
    var halb = q % 2;
    if (halb === 1) return (ganz > 0 ? ganz + ',5' : '0,5') + ' m';
    return ganz + ' m';
  }

  function apply(cart) {
    var mengen = {};
    (cart.items || []).forEach(function (i) {
      if (i.properties && i.properties[PROP_KEY]) mengen[i.variant_id] = i.quantity;
    });

    document.querySelectorAll(SEL).forEach(function (box) {
      var wrap = box.closest('[data-essential-cart-element="cart-drawer-item-details"]') || box.parentElement;
      if (!wrap) return;
      var link = wrap.querySelector('a[href*="variant="]');
      if (!link) return;
      var treffer = link.getAttribute('href').match(/variant=(\d+)/);
      if (!treffer) return;
      var q = mengen[treffer[1]];
      if (!q) return;

      var text = 'Gesamt: ' + meter(q) + ' – am Stück geliefert';
      if (box.getAttribute(MARK) === text) return;
      box.textContent = text;
      box.setAttribute(MARK, text);
    });
  }

  function run() {
    if (busy) return;
    if (!document.querySelector(SEL)) return;
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(apply)
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(run, 300);
  }

  function start() {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    schedule();
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
